import { useEffect, useState } from "react";
import { accountSettings, logged } from "../../api/client";
import { useDispatch, useSelector } from "react-redux";
import {
  logout,
  updateAccountInfo,
  updateAccountSettings,
  updatePaymentModalInit,
  updateUnreads,
} from "../../store/slicers/authSlice";
import Confetti from "react-confetti";
import BeatLoader from "react-spinners/BeatLoader";
import { getServices } from "../../api/client/listing";
import { updatePopular } from "../../store/slicers/listingSlice";
import { InitialPayoutDetails } from "../merchant/InitialPayoutDetails";
const CLogged = ({ children }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const showPaymentInit = useSelector((state) => state.auth.showPaymentInit);
  const fetchData = async () => {
    try {
      const response = await logged();
      if (response.error === 0) {
        const accountInfo = response.data.account_info;
        if (accountInfo.new_account) {
          dispatch(logout());
        }
        if (accountInfo?.merchant_info) {
          //check if merong bank details and listing
          if (accountInfo?.merchant_info?.bank_info === "0" && accountInfo?.merchant_info?.has_listing === "1") {
            // show ung payment details modal
            dispatch(updatePaymentModalInit(true));
          }
        }
        dispatch(
          updateUnreads({
            notif: response.data.unread_notif,
            msg: response.data.unread_msg,
            merchantMsg: response?.data?.unread_msg_merchant || 0,
          })
        );
        dispatch(updateAccountInfo(accountInfo));
        getAccountSettings();
      } else {
      }
      getPopular()
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      // call logout
    }
  };

  const getPopular = async () => {
    try {
      const _requestData = {
        flag: 'popular',
      };
      const response = await getServices(_requestData);
      if (response.error === 0) {
        dispatch(updatePopular(response.data.services_list));
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const getAccountSettings = async () => {
    try {
      const _requestData = {
        flag: "init",
      };
      const response = await accountSettings(_requestData);
      if (response.error === 0) {
        dispatch(updateAccountSettings(response.data.account_settings));
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return isLoading ? (
    <>
      <div className="bg-primary-500 h-screen w-full">
        <div className="fixed inset-0 flex items-center justify-center z-50 text-white">
          <div className=" rounded-3xl relative w-500">
            <div className="modal-content">
              <div className="flex justify-right h-16 ">
                <div
                  className="anyaya h-full w-full"
                  style={{ backgroundPositionX: "center" }}
                />
              </div>
              <div className="mt-10" style={{ textAlignLast: "center" }}>
                <BeatLoader color="#fff" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Confetti
        width={window.innerWidth - 20}
        height={window.innerHeight - 20}
        tweenDuration={1}
      />
    </>
  ) : (
    <>
      {children}


      {showPaymentInit &&
        <InitialPayoutDetails isLogged={true} />
      }
    </>
  );
};

export default CLogged;
